import React, { useState } from 'react';
import axios from '../backendService';
import { Row, Col, Form, Input, Button, message as antMessage, PageHeader } from 'antd';

function Paid() {
  const [form] = Form.useForm();

  const handleSubmit = async (values) => {
    try {
      const response = await axios.post('notification/paid', values);
      // console.log('Response:', response.data);
      antMessage.success('Notifications sent successfully.');
      form.resetFields(); // Reset form fields after submission
    } catch (error) {
      console.error('Error sending notifications:', error);
      antMessage.error('Failed to send notifications.');
    }
  };

  return (
    <>
      <PageHeader
        className="flex items-center justify-between px-8 xl:px-[15px] pt-7 pb-6 sm:pb-[30px] bg-transparent sm:flex-col"
        title="  "
      />

      {/* <main className="min-h-[715px] lg:min-h-[580px] px-8 xl:px-[15px] bg-transparent mx-20"> */}
      <main className="min-h-[715px] lg:min-h-[580px] px-8 xl:px-[15px] bg-transparent mx-20">
        <Row gutter={35} justify="center">
          <Col xs={20}>
            {/* <Row gutter={30}>
          <Col xs={24}> */}
            <>
              <div className="bg-white dark:bg-white10 text-theme-gray dark:text-white60 text-[15px] rounded-10 relative p-[25px] mx-20">
                <div className="dark:bg-white10 m-0 p-0 text-theme-gray dark:text-white60 text-[15px] rounded-10 relative h-full">
                  <div className="h-[60px] px-[25px] text-dark dark:text-white87 font-medium text-[17px] border-regular dark:border-white10 border-b">
                    <h1 className="mb-0 inline-block py-[16px] overflow-hidden whitespace-nowrap text-ellipsis text-[18px] font-semibold">
                      Subscribed User Notification Form
                    </h1>
                  </div>
                  <div className="p-[25px]">
                    <Form name="horizontal-form" layout="horizontal" onFinish={handleSubmit} form={form}>
                      <Row align="middle">
                        <Col lg={8} md={9} xs={24}>
                          <label className="font-medium mb-[24px] block dark:text-white60">Title</label>
                        </Col>
                        <Col lg={16} md={15} xs={24}>
                          <Form.Item name="title" rules={[{ required: true, message: 'Please input a title!' }]}>
                            <Input placeholder="Enter Notification Title" />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row align="middle">
                        <Col lg={8} md={9} xs={24}>
                          <label className="font-medium mb-[24px] block dark:text-white60">Message</label>
                        </Col>
                        <Col lg={16} md={15} xs={24}>
                          <Form.Item name="message" rules={[{ required: true, message: 'Please input a message!' }]}>
                            {/* <Input placeholder="Type Your Notification Message Here" /> */}
                            <Input.TextArea rows={4} placeholder="Type Your Notification Message Here" />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={{ span: 16, offset: 8 }} md={{ span: 15, offset: 9 }} xs={{ span: 24, offset: 0 }}>
                          <div className="flex flex-wrap gap-[15px]">
                            <Button
                              className="bg-primary hover:bg-hbr-primary border-solid border-1 border-primary text-white dark:text-white87 text-[14px] font-semibold leading-[22px] inline-flex items-center justify-center rounded-[4px] px-[20px] h-[44px]"
                              type="primary"
                              size="large"
                              htmlType="submit"
                            >
                              Send to Subscribers
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </div>
              </div>
            </>
          </Col>
        </Row>
      </main>
    </>
  );
}

export default Paid;
